export class UserModel {
  title: string = "";
  firstName: string = "";
  lastName: string = "";
  email: string = "";
  mobileNumber: string = "";
  aliasName: string = "";
  employeeCode: string = "";
  branch: string = "";
  status: string = "";
  corporateName: string = "";
  role: string = "";
  roleId: string = "";
  feature_ids: string[] =[ ""];

  constructor(data?: Partial<UserModel>) {
    Object.assign(this, data);
  }
}
